import { isWebView } from "../bridges/BridgeServices";

export const isTokenPresent = () => {
  if (typeof window === "undefined") {
    return false;
  }

  // Pre-Login
  // On Mobile, if user is accessing FAQ on mobile browser -- that will be a pre-login scenario where FAQ will not open in WebView
  // On Web, if user is accessing pre-login FAQ, then FAQ will not open in Iframe, hence isTokenPresent will be false.

  //Post-Login
  // On Mobile, if user is accessing FAQ on mobile app -- then FAQ will open in WebView
  // On Web, if user is accessing post-login FAQ, then FAQ will  open in Iframe, hence isTokenPresent will be true.

  return isWebView() || isInsideIframe();
};

export const isInsideIframe = () => {
  return parent !== window;
};
